export const PROPERTY_TABS = [
  { id: "basic", label: "المعلومات الأساسية" },
  { id: "contract", label: "العقد والسعر" },
  { id: "physical", label: "الخصائص" },
];

export const STATUS_OPTIONS = [
  { value: "draft", label: "مسودة" },
  { value: "pending", label: "قيد المراجعة" },
  { value: "approved", label: "مفعل" },
  { value: "archived", label: "مؤرشف" },
];

export const CONTRACT_TYPE_OPTIONS = [
  { value: "إيجار", label: "إيجار" },
  { value: "بيع", label: "بيع" },
];

export const RENT_FREQUENCY_OPTIONS = [
  { value: "daily", label: "يومي" },
  { value: "monthly", label: "شهري" },
  { value: "yearly", label: "سنوي" },
];

export const AMENITIES_OPTIONS = [
  { value: "parking", label: "موقف سيارات" },
  { value: "elevator", label: "مصعد" },
  { value: "pool", label: "مسبح" },
  { value: "gym", label: "صالة رياضية" },
  { value: "garden", label: "حديقة" },
  { value: "balcony", label: "شرفة" },
  { value: "air_conditioning", label: "تكييف" },
  { value: "security", label: "خدمة أمن" },
  { value: "kitchen", label: "مطبخ مجهز" },
  { value: "wifi", label: "واي فاي" },
  { value: "storage_room", label: "مستودع" },
];

export const getYearValue = (value: string) => {
  if (!value) return "";
  if (/^\d{1,4}$/.test(value)) return value;
  const match = value.match(/^(\d{4})-\d{2}-\d{2}$/);
  if (match) return match[1];
  return "";
};

export const toConstructionDate = (year: string) => {
  const sanitized = year.replace(/\D/g, "");
  if (!sanitized) return "";
  if (sanitized.length < 4) return sanitized;
  return `${sanitized.slice(0, 4)}-01-01`;
};
